import { useMemo } from 'react'
import { useEthers } from './EthersProvider'
import ABI from './abi'
import { OLD_TOKEN_ADDRESS, NEW_TOKEN_ADDRESS } from './config'
import useProvider from './useProvider'

export default function useTokens() {
    const provider = useProvider()

    const { Contract } = useEthers()

    return useMemo(() => (provider && Contract ? {
        // New DATA token contract
        dataToken: new Contract(NEW_TOKEN_ADDRESS, ABI, provider),
        // Old DATA token contract (-> XDATA)
        xdataToken: new Contract(OLD_TOKEN_ADDRESS, ABI, provider),
    } : {}), [provider, Contract])
}
